module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_jonkoping-295d68ef069d5cad77c6b0751c6127ed.png";